<template>
  <div class="w w1200">
    <!-- 面包屑导航 -->
    <el-breadcrumb
      class="breakcrumbHeader"
      separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商家入驻申请</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="20">
      <el-col :span="6">
        <div class="aside">
          <h4 class="aside-title">商家入驻指南</h4>
          <ul class="aside-list">
            <li class="aside-item active">签订入驻协议</li>
            <li class="aside-item">填写商家资料</li>
            <li class="aside-item">平台审核</li>
            <li class="aside-item">合同签订及缴费</li>
            <li class="aside-item">店铺开通</li>
          </ul>
        </div>
        <div class="aside">
          <h4 class="aside-title">平台联系方式</h4>
          <ul class="aside-list">
            <li class="aside-item">电话：{{informations.consumerHotline}}</li>
            <li class="aside-item">邮箱：{{informations.eMail}}</li>
          </ul>
        </div>
      </el-col>
      <el-col :span="18" class="rightaside">
        <el-card header="入驻协议" shadow="never">
          <div v-html="agreementContents"></div>
          <div class="checkbox">
            <el-checkbox v-model="sizeForm.checkedBox">我已阅读并同意以上协议</el-checkbox>
            <span v-show="errerInfo" style="color:var(--main-theme-color);margin-left:15px">请勾选 </span>
          </div>
          <div class="btn-box">
            <el-button type="primary" :disabled="!sizeForm.checkedBox" @click="nextEditResource('ruleForm')">下一步，填写资料
            </el-button>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {agreementContent} from "@/api/xunyou";

export default {
  data() {
    return {
      agreementContents: '',
      errerInfo: false,
      sizeForm: {
        checkedBox: false,
      }
    };
  },
  computed:{
    informations() {
      return this.$store.state.copyrights
    }
  },
  mounted() {
    this.getAgreementContent()
  },
  methods: {
    // 获取协议内容
    getAgreementContent() {
      agreementContent().then((res) => {
        if (res.code == 0) {
          this.agreementContents = res.rows[0].work;
        }
      }).catch((err) => {
        this.$message.error("查询协议内容失败，请稍后再试！");
      });
    },

    nextEditResource() {
      if (this.sizeForm.checkedBox) {
        this.errerInfo = false;
        this.$router.push('/settleIn/merchantForm');
      } else {
        this.errerInfo = true;
      }
    }
  },
};
</script>

<style scoped lang="less">
.breakcrumbHeader {
  margin: 15px 0;
}
/deep/ .el-card__header{
  padding: 10px 20px;
  font-size: 18px;
  font-weight: 500;
}
.aside {
  box-sizing: border-box;
  font-size: 14px;
  margin-right: 10px;
  margin-bottom: 40px;
  background-color: #fff;

  .aside-title {
    padding: 10px;
    border-bottom: 1px solid #ddd;
    font-size: 16px;
    font-weight: 700;
  }

  .aside-item {
    padding: 10px;

    &.active {
      color: var(--main-theme-color);
    }
  }
}

.checkbox {
  padding: 10px 0;
}

</style>







// WEBPACK FOOTER //
// src/views/merchantSettled/merchantApply.vue